import React, { useState } from 'react';
import classNames from 'classnames';

interface IFormFieldProps {
    label: string;
    placeholder?: string;
    name: string;
    value: string | null;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    error?: string | null;
    inputType?: string | null;
    autocomplete?: string | null;
}

export default function FormField({ label, placeholder, value, onChange, error, inputType, autocomplete, name }: IFormFieldProps) {
    const baseCssClass = 'bs-form-field-container-component';
    const [showError, setShowError] = useState(false);

    const inputClass = classNames(`${baseCssClass}__input`, {
        [`${baseCssClass}__input--error`]: !!error && showError
    });

    const errorMessageClass = classNames(`${baseCssClass}__error-message`, {
        [`${baseCssClass}__error-message--hidden`]: !error
    });

    return (
        <div className={baseCssClass}>
            <label className={`${baseCssClass}__label`} htmlFor={label}>
                {label}
            </label>

            <input
                type={inputType || 'text'}
                className={inputClass}
                id={label?.replace(' ', '-').toLowerCase()}
                placeholder={placeholder}
                value={value || ''}
                autoComplete={autocomplete || 'hidden'}
                name={name}
                onChange={e => {
                    onChange(e);
                    if (!showError) {
                        setShowError(true);
                    }
                }}
            />

            <span className={errorMessageClass}>{showError && error}</span>
        </div>
    );
}
